import React, { useState } from "react";
import WeekFilter from "./_filter";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import { DateTime } from "luxon";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useNavigate } from "react-router-dom";

function ListWeek({
  goForwardMonth,
  goBackMonth,
  goBackWeek,
  maxItems,
  setMaxItems,
  goForwardWeek,
  dateStart,
  dateEnd,
  lastWeek,
  data,
  avarageKwh
}) {
  const navigate = useNavigate();
  const range1 = avarageKwh + 3
  const range2 = avarageKwh
  return (
    <div className="week_list">
      <p className="week_list-title">Consulta la tabella completa</p>
      <p className="week_list-secondary">
        Di seguito è riportata la tabella per i tuoi consumi e spese suddivisa
        mensilmente.
      </p>
      <div className="week_list-filter">
        <div className="week_list-filter_date">
          <WeekFilter
            goForwardWeek={() => goForwardWeek()}
            goBackWeek={() => goBackWeek()}
            goBackMonth={() => goBackMonth()}
            goForwardMonth={() => goForwardMonth()}
            dateStart={dateStart}
            dateEnd={dateEnd}
            lastWeek={lastWeek}
          />
        </div>
        <div className="week_list-filter_letture">
          <div
            className="week_list-filter_letture-container"
            onClick={() => navigate("/enrica/letture")}
          >
            <p>Letture</p>
            <ArrowForwardIosIcon />
          </div>
        </div>
      </div>
      <div className="week_list-items">
        <div className="week_list-item-index">
          <p className="week">Giorno</p>
          <p className="prezzo">Prezzo</p>
          <p className="kwh">kWh</p>
          <p className="euro">Euro</p>
          <div className="icon"></div>
        </div>
        {data &&
          data.slice(0, maxItems).map(
            (r) =>
              r.id && (
                <div className="week_list-item">
                  <p className="week">
                    {DateTime.fromISO(r.datamisura).toFormat("EEEE")}
                  </p>
                  <p className="prezzo">
                    {parseFloat(r.qv).toFixed(2).replace(/\./g, ",")}
                  </p>
                  <p className="kwh">
                    {parseFloat(r.kwh_tot).toFixed(2).replace(/\./g, ",")}
                  </p>
                  <p className="euro">
                    {parseFloat(r.spesa_giorno).toFixed(2).replace(/\./g, ",")}
                  </p>
                  <div className="icon" style={r.kwh_tot > range1 ? {background: 'red'} : r.kwh_tot < range2 ? {background: 'green'} : {background: 'orange'}}></div>
                </div>
              )
          )}
      </div>
      {data && data.filter((d) => d.id !== null).length >= maxItems ? (
        <div
          className="week_list-more"
          onClick={() => setMaxItems(maxItems + 6)}
        >
          <p>Mostra di più</p>
          <KeyboardArrowDownIcon />
        </div>
      ) : (
        <div className="week_list-more">
          <p>Nient'altro da visualizzare.</p>
        </div>
      )}
    </div>
  );
}

export default ListWeek;
